import { z } from "zod";

const decimalToNumber = z
  .union([z.number(), z.string(), z.null(), z.undefined()])
  .transform((value) => {
    if (value === null || value === undefined) {
      return null;
    }
    if (typeof value === "number") {
      return value;
    }
    const parsed = Number.parseFloat(value);
    return Number.isNaN(parsed) ? null : parsed;
  })
  .nullable()
  .optional();

export const productSchema = z.object({
  id: z.number(),
  sku: z.string(),
  name: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  picture: z.string().nullable().optional(),
  price: decimalToNumber,
  quantity_available: decimalToNumber,
  quantity_reserved: decimalToNumber,
  quantity_available_for_sale: decimalToNumber,
  uom: z.string().nullable().optional(),
  erp_item_id: z.string().nullable().optional(),
  supplier: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const productsSchema = z.array(productSchema);

export type Product = z.infer<typeof productSchema>;
